module.exports = __webpack_public_path__ + "img/approval-management.3f2c9a13.svg";